<!-- <nav aria-label="breadcrumb" >
  <ol class="breadcrumb padding-left bottomLine" style="margin-block-start: 0px !important;margin-block-end: 4px !important;margin-inline-start: 0px !important;margin-inline-end: 0px !important;padding-inline-start: 6px !important;">
    <li class="breadcrumb-item breamcrumb-text" (click)="navigation('firstLevel',firstLevel)">{{firstLevel}}</li>
    <li class="breadcrumb-item breamcrumb-text" [ngClass]="thirdLevel == null ? 'lastNode' : ''" *ngIf="secondLevel" (click)="navigation('secondLevel',secondLevel)"><a >{{secondLevel}}</a></li>
    <li class="breadcrumb-item breamcrumb-text"  [ngClass]="fourthLevel == null ? 'lastNode' : ''" aria-current="page" *ngIf="thirdLevel" (click)="navigation('thirdLevel',thirdLevel)">{{thirdLevel}}</li>
    <li id="fourthlevelbreadcrumb" class="breadcrumb-item breamcrumb-text lastNode"  aria-current="page" *ngIf="fourthLevel" (click)="navigation('fourthLevel',fourthLevel)">{{fourthLevel}}</li>
    <li class="breadcrumb-item breamcrumb-text lastNode"  aria-current="page" *ngIf="fifthLevelFromDependency" (click)="navigation('fifthLevelFromDependency',fifthLevelFromDependency)">{{fifthLevelFromDependency}}</li>
    <li class="breadcrumb-item breamcrumb-text lastNode"  aria-current="page" *ngIf="sixthLevelFromDependency" (click)="navigation('sixthLevelFromDependency',sixthLevelFromDependency)">{{sixthLevelFromDependency}}</li>
  </ol>
</nav> 
 -->
 <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" style="border-left: 5px solid #005C8A;">
  <ol
    class="breadcrumb breadcrumb_bg">
    <li
      class="breadcrumb-item breamcrumb-text"
      (click)="navigation('firstLevel', firstLevel)"
    >
      {{ firstLevel }}
    </li>
    <li
      class="breadcrumb-item breamcrumb-text"
      [ngClass]="thirdLevel == null ? 'lastNode' : ''"
      *ngIf="secondLevel"
      id="secondLevelid"
      (click)="navigation('secondLevel', secondLevel)"
    >
      <a>{{ secondLevel }}</a>
    </li>
    <li
      class="breadcrumb-item breamcrumb-text"
      [ngClass]="fourthLevel == null ? 'lastNode' : ''"
      aria-current="page"
      *ngIf="thirdLevel"
      (click)="navigation('thirdLevel', thirdLevel)"
    >
      {{ thirdLevel }}
    </li>
    <li
      id="fourthlevelbreadcrumb"
      class="breadcrumb-item breamcrumb-text lastNode"
      aria-current="page"
      *ngIf="fourthLevel"
      (click)="navigation('fourthLevel', fourthLevel)"
    >
      {{ fourthLevel }}
    </li>
    <li
      class="breadcrumb-item breamcrumb-text lastNode"
      aria-current="page"
      *ngIf="fifthLevelFromDependency"
      (click)="navigation('fifthLevelFromDependency', fifthLevelFromDependency)"
    >
      {{ fifthLevelFromDependency }}
    </li>
    <li
      class="breadcrumb-item breamcrumb-text lastNode"
      aria-current="page"
      *ngIf="sixthLevelFromDependency"
      (click)="navigation('sixthLevelFromDependency', sixthLevelFromDependency)"
    >
      {{ sixthLevelFromDependency }}
    </li>
  </ol>
</nav>
